export const horarioData = [
  {days: 'Martes', morning: '9:30 - 13:00', afternoon: '15:00 - 20:00'},
  {days: 'Miercoles', morning: '9:30 - 13:00', afternoon: '15:00 - 20:00'},
  {days: 'Jueves', morning: '9:30 - 13:00', afternoon: '15:00 - 20:00'},
  {days: 'Viernes', morning: '9:30 - 13:00', afternoon: '15:00 - 20:00'},
  {days: 'Sabado', morning: '9:30 - 13:00', afternoon: '15:00 - 20:00'},
];